export async function requestNotificationPermission() {
  if (!("Notification" in window)) {
    alert("This browser does not support notifications.");
    return;
  }

  try {
    const permission = await Notification.requestPermission();

    switch (permission) {
      case "granted":
        console.log("Notification permission granted.");
        break;
      case "denied":
        console.log("Notification permission denied.");
        break;
      case "default":
        console.log("Notification permission request dismissed.");
        break;
      default:
        console.log("Unknown notification permission state:", permission);
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
  }
}
